import { schema } from "normalizr";
import { BrandedLoginRecord } from "records/brand/branded-login";

export const BrandedLogin = new schema.Entity(
    "brandedLogin",
    {},
    {
        idAttribute: "name", // we really only reference using slug (aka name)
    }
);

BrandedLogin.record = BrandedLoginRecord;
